/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteJobModal_job$ref: FragmentReference;
declare export opaque type DeleteJobModal_job$fragmentType: DeleteJobModal_job$ref;
export type DeleteJobModal_job = {|
  +id: string,
  +name: string,
  +order: ?{|
    +id: string
  |},
  +$refType: DeleteJobModal_job$ref,
|};
export type DeleteJobModal_job$data = DeleteJobModal_job;
export type DeleteJobModal_job$key = {
  +$data?: DeleteJobModal_job$data,
  +$fragmentRefs: DeleteJobModal_job$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "DeleteJobModal_job",
  "type": "Job",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "order",
      "storageKey": null,
      "args": null,
      "concreteType": "Order",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c0fed24296606ea50cbe7b22eb96d579';
module.exports = node;
